module.exports = __webpack_public_path__ + "img/Jd.edd33164.png";